module.exports = __webpack_public_path__ + "img/posture_perfect1.7537bb3a.png";